import { getTileQuestionsAnswers } from '../answers.api';
import { TileQuestionsAnswers } from '../answers.types';

export const getSlowBrainTileQuestionsAnswers = async (
	clientId: string | number
): Promise<TileQuestionsAnswers> => {
	return getTileQuestionsAnswers(clientId, 'slow_brain');
};
